export default __webpack_public_path__ + "static/OYOY-2160x438-60fps-dc2f2005a369fd173f1efd869080af7b.mp4";